<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="id"
          :item-class="getRowColor"
          class="elevation-1"
          :single-expand="true"
          :expanded.sync="expanded"
          show-expand
        >
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="8">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      currentPage: 1,
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Vacina',
          align: 'start',
          filterable: false,
          value: 'no_imuno',
        },
        {
          text: 'Dose',
          align: 'start',
          filterable: false,
          value: 'no_dose_imuno',
        },
        {
          text: 'Aplicacão',
          align: 'start',
          filterable: false,
          value: 'dt_aplicacao',
        },
        {
          text: 'Atendimento',
          align: 'start',
          filterable: false,
          value: 'dt_atendimento',
        },
        {
          text: 'Profissional',
          align: 'start',
          filterable: false,
          value: 'profissional',
        },
        {
          text: 'Cidadão',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     *
     * @returns {String}
     */
    getRowColor(item) {
      return 'color-red'
    },
  },
}
</script>

<style scoped lang="scss"></style>
